import styled from 'styled-components';
import VIDEO_LIST_IMAGE from '../../../../assets/images/pluvaAutoBusiness/full.png';
import { postMessageToRN } from '../../../../utils/RNCommunicator/postMessageToRN.util';

const YOUTUBE_PLAYLIST_URL =
  'https://www.youtube.com/watch?v=O9sGycIFN7w&list=PLH3vv0_FUaJ3rRef64ak5JGUMC5acaUEB&index=1';

export const GoToYoutubePlayList = () => {
  const handleButtonClick = () => {
    if (window.ReactNativeWebView) {
      postMessageToRN({ messageKey: 'link', messageParam: YOUTUBE_PLAYLIST_URL });
    } else {
      window.open(YOUTUBE_PLAYLIST_URL, '_blank', 'popup=yes, width=800, height=700, top=20, left=120');
    }
  };

  return (
    <GoToVideoListBackground>
      <GreenChipButton onClick={handleButtonClick}>
        <GreenChipButtonText>{'영상 전체 재생'}</GreenChipButtonText>
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
          <path
            d="M1.26999 11.67C1.05999 11.67 0.849986 11.6 0.709986 11.46C0.429986 11.18 0.499986 10.76 0.779986 10.48L5.74999 6.14001L0.779986 1.66001C0.499986 1.38001 0.429986 0.960011 0.709986 0.680011C0.989986 0.400011 1.40999 0.33001 1.68999 0.61001L7.28999 5.51001C7.42999 5.65001 7.49999 5.86001 7.49999 6.07001C7.49999 6.28001 7.42999 6.49001 7.28999 6.63001L1.68999 11.53C1.54999 11.6 1.40999 11.67 1.26999 11.67Z"
            fill="white"
          />
        </svg>
      </GreenChipButton>
      <Image imagePath={VIDEO_LIST_IMAGE} />
    </GoToVideoListBackground>
  );
};

const GoToVideoListBackground = styled.div`
  position: relative;

  height: 200px;
  min-width: 250px;
  min-height: 200px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;

  padding: 24px;
  gap: 10px;

  border-radius: var(--radius-large, 16px);

  overflow: hidden;

  background-color: red;
`;

const Image = styled.div<{ imagePath: string }>`
  min-width: 750px;
  min-height: 533px;

  background: ${(props) => `url(${props.imagePath}) lightgray 50% / cover no-repeat`};

  border-radius: var(--radius-large, 16px);
`;

const GreenChipButton = styled.div`
  position: absolute;

  top: 50%;
  left: 50%;

  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--radius-medium, 8px) var(--radius-large, 16px);
  gap: var(--radius-small, 4px);
  flex-shrink: 0;

  border-radius: var(--radius-round, 80px);
  background: var(--Light-Scheme-Color-primary-green, #34c77e);

  transform: translate(-50%, -50%);

  cursor: pointer;
`;

const GreenChipButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);
  text-align: center;

  /* Display/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;
